import React, { useEffect, useState } from 'react';
import { DialogContent } from './dialog';

// visualViewport follows the visible area when a phone's keyboard is open.
// Only the dialog body scrolls; the header and submit controls stay reachable.
export const WorkflowDialogContent = ({ children, className = '', ...props }) => {
  const [viewport, setViewport] = useState(null);
  useEffect(() => {
    const visual = window.visualViewport;
    if (!visual) return;
    const update = () => setViewport({ height: visual.height, top: visual.offsetTop });
    update();
    visual.addEventListener('resize', update);
    visual.addEventListener('scroll', update);
    return () => {
      visual.removeEventListener('resize', update);
      visual.removeEventListener('scroll', update);
    };
  }, []);
  return <DialogContent {...props} className={`workflow-dialog ${className}`} style={viewport ? {
    '--workflow-visible-height': `${viewport.height}px`,
    top: `${viewport.top + viewport.height / 2}px`,
  } : undefined}>{children}</DialogContent>;
};